<template>
  <div>
    <div class="table-box" style="paddingTop:10px">
      <el-button
        @click="back"
        type="text"
        style="display:flex"
        icon="el-icon-arrow-left"
      >
        返回
      </el-button>
      <!--列表-->
      <div>
        <searchbar
          :isAuto="true"
          :searchEvent="searchEvent.bind(this)"
          :parent="this"
        />
        <el-table
          style="width: 100%"
          v-loading="loading"
          row-key="id"
          ref="recordList"
          :data="tableData"
          :stripe="false"
          :highlight-current-row="false"
          header-row-class-name="noBorder"
        >
          <el-table-column
            type="index"
            label="序号"
            align="center"
            width="80"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="fullName"
            label="项目参与人"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            v-if="projectStructureType === 2"
            align="center"
            prop="userEnterpriseName"
            label="个体"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="phone"
            label="手机号"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            prop="taskCode"
            label="任务编码"
          ></el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="状态"
          >
            <template slot-scope="scope">
              {{ scope.row.auditGongyeStatus | transAuditStatus }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150" align="center">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="check(scope.row)">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <!--分页-->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="paginationData.pageNum"
          :total="totalElements"
          :page-size="paginationData.pageSize"
          layout="total, prev, pager, next, jumper"
          style="padding:15px"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
// import datePicker from "@/Mixin/datePicker";
import { project, digitalQuestionnaire } from '@/api/ajax';
import { pageInation } from '@/Mixin/listMixin';
import { initSearch } from '@/Mixin/initSearch';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect.vue';
import taskRecordHandles from '@/Mixin/taskRecordHandles';
import searchbar from '@/components/Survey/searchbar';
import rejectComponent from '@/components/Task/components/reject.vue';
import OpenNewWin from '@/tools/openNewWin';
import approvalFlagMixins from '@/Mixin/approvalFlagMixins';
import { setStorage, getStorage } from '@/tools/storage';

export default {
  mixins: [pageInation, makeSure, taskRecordHandles, approvalFlagMixins],
  data() {
    return {
      showArrow: true,
      carouselIndex: 0,
      dialogVisible: false,
      imagesList: [],
      authType: 0,
      projectStructureType: getStorage('homeProject').projectStructureType || 1,
      ruleForm: {}, // 用户信息
      getList: digitalQuestionnaire.taskRecordList, // 获取列表的AJAX
      searchQuery: {
        projectId: this.$route.query.projectId,
        taskDt: this.$route.query.month,
        type: 2,
        statementId: this.$route.query.statementId,
        ...getStorage('recordsearchQuery')
      },
      prop: {
        label: 'projectName',
        code: 'id'
      },
      searchAjax: project.crmProjectList,
      extraObj: {
        type: 1
      }
    };
  },
  components: {
    dicSelect,
    searchbar,
    rejectComponent
  },
  computed: {
    showHr(imgArr, index) {
      return (imgArr, index) => {
        return !imgArr || !imgArr[index] || imgArr[index] == 'null';
      };
    }
  },
  methods: {
    back() {
      localStorage.removeItem('recordsearchQuery');
      this.$router.back();
    },
    iframeLoad() {
      this.$nextTick(_ => {
        let ifrDom = document.getElementById('iframe');
        setTimeout(_ => {
          this.ifrHeight =
            ifrDom.contentWindow.document.documentElement.scrollHeight + 'px';
        }, 1500);
      });
    },
    check(row) {
      setStorage('recordsearchQuery', this.searchQuery);
      //去详情
      let { id } = this.$route.query;
      this.$router.push({
        name: 'digitalQuestionnaireRecordDetail',
        query: {
          projectId: this.$route.query.projectId,
          taskId: row.taskId
        }
      });
    },
    dateChange(val) {},
    saveProId(val) {
      this.searchQuery.projectId = val.id;
    },
    exportEvent() {
      if (this.searchQuery.projectId && this.searchQuery.taskDt) {
        let queryString = this.$querystring.stringify(this.searchQuery);
        window.open(project.exportNumbervisitRecord + '?' + queryString);
      } else {
        this.$message.error('请选择条件');
      }
    },
    saveEnterpriseId(val) {
      //保存
      this.searchQuery.enterpriseId = val.id;
    },
    add() {
      this.$router.push({
        name: 'salerAdd'
      });
    },
    pass(scope, status) {
      let delEvent = scope => {
        let { $index, row } = scope;
        visit
          .pass({
            id: row.id,
            status
          })
          .then(res => {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
            this.initWatchRouteChange();
          });
      };
      this.makeSureEvent(delEvent, scope);
    }
  },
  filters: {
    transTag(val) {
      if (val == 0) {
        return '差';
      } else if (val == 1) {
        return '一般';
      } else if (val == 2) {
        return '积极';
      } else if (val == 3) {
        return '好';
      } else if (val == 4) {
        return '很好';
      }
    },
    transAuditStatus(val) {
      // console.log(val);
      if (val == 1) {
        return '审核中';
      } else if (val == 2) {
        return '审核通过';
      } else if (val == 3) {
        return '审核未通过';
      }
    }
  },
  mounted() {
    this.authType = +(localStorage.getItem('authType') || 0);
    // this.approveCheck()
  }
};
</script>
<style lang="scss" scoped>
.table-box {
  margin: 0;
}
.table-dialog {
  .el-carousel__item {
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      /*max-height: 600px;*/
      height: inherit;
    }
  }
}

.table-pic {
  object-fit: contain !important;
}

.show-modal-ca {
  /*width: 100%!important;*/
  height: 100% !important;
  object-fit: contain !important;
}
</style>
